import React from 'react';
import classnames from 'classnames';

import WpImage from 'components/Elements/WPImage';
import * as styles from './styles.module.scss';

const Hero = ({ data }) => (
  <div className={styles.hero}>
    <div className={styles.hero_img}>
      <WpImage
        src={data.blog.banner?.sourceUrl}
        alt={data.blog.banner?.title}
        className={styles.imgContainer}
      />
    </div>

    <div className={classnames('cr-story-wrap', styles.hero_inner)}>
      <div className={styles.hero_txt}>
        <p
          className={classnames(
            'cr-text-3 cr-subheader-4',
            styles.hero_txt_suptitle
          )}
        >
          {data.categories?.nodes.map(({ name }) => name).join(' ')}
        </p>
        <h1 className={classnames('cr-white cr-h2')}>{data.title}</h1>
      </div>
    </div>
  </div>
);

export default Hero;
